export const FETCH_RESULTS = 'FETCH_RESULTS';
export const LIST_RESULTS = 'LIST_RESULTS';





